module.exports = __webpack_public_path__ + "static/img/zanwucaiE.59cbef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zanwucaiE.png
// module id = xXhy
// module chunks = 1